<template>
  <div id="LayerBill">
    <br />
    <br />
    <div v-for="(cache, index) of cachetDate" :key="index">
      <div class="cacheImg" :style="{ top: cache.y, left: cache.x }">
        <img :src="cache.imgUrl" />
      </div>
    </div>

    <table width="700" align="center" border="0" cellspacing="0" class="outtable" id="allTable">
      <tbody>
        <tr>
          <td>
            <table width="700" border="0" align="center" cellspacing="0" class="outtable">
              <tbody>
                <tr>
                  <td colspan="4">
                    <div align="center" style="font-size: 22px; font-weight: bold">最高开票限额申请表</div>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    <table
                      width="600"
                      align="center"
                      border="0"
                      cellpadding="0"
                      cellspacing="0"
                      class="thickbordertable"
                    >
                      <tbody>
                        <tr>
                          <td height="339">
                            <table width="600" align="center" border="0" cellspacing="0" class="billtable" id="Table1">
                              <tbody>
                                <tr>
                                  <td width="11%" rowspan="4" align="center">
                                    申请事
                                    <br />
                                    项(由企
                                    <br />
                                    业填写)
                                  </td>
                                  <td width="11%" align="center">企业名称</td>
                                  <td width="36%">
                                    <input :value="aBill.a1" type="text" style="width: 210px" />
                                  </td>
                                  <td width="11%" align="center">
                                    税务登记
                                    <br />
                                    代码
                                  </td>
                                  <td width="31%">
                                    <input
                                      :value="aBill.a2"
                                      name="A[0].a2"
                                      cname="a2"
                                      type="text"
                                      style="width: 180px"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td align="center">地 址</td>
                                  <td>
                                    <input
                                      :value="aBill.a3"
                                      name="A[0].a3"
                                      cname="a3"
                                      type="text"
                                      style="width: 210px"
                                    />
                                  </td>
                                  <td align="center">联系电话</td>
                                  <td>
                                    <input
                                      :value="aBill.a4"
                                      name="A[0].a4"
                                      cname="a4"
                                      type="text"
                                      style="width: 180px"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td height="46" align="center">
                                    申请最高
                                    <br />
                                    开票限额
                                  </td>
                                  <td colspan="3">
                                    &nbsp;&nbsp;
                                    <input name="A[0].a30" cname="a30" type="checkbox" style="width: 16px" value="1" />
                                    一亿元
                                    <input name="A[0].a31" cname="a31" type="checkbox" style="width: 16px" value="1" />
                                    一千万元
                                    <input name="A[0].a2" cname="a32" type="checkbox" style="width: 16px" value="1" />
                                    一百万元
                                    <br />
                                    &nbsp;&nbsp;
                                    <input
                                      name="A[0].a33"
                                      cname="a33"
                                      type="checkbox"
                                      style="width: 16px"
                                      value="1"
                                      checked=""
                                    />
                                    十万元
                                    <input name="A[0].a34" cname="a34" type="checkbox" style="width: 16px" value="1" />
                                    一万元&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input name="A[0].a35" cname="a35" type="checkbox" style="width: 16px" value="1" />
                                    一千元
                                    <br />
                                    &nbsp;&nbsp;&nbsp;(请在选择数额前的□内打“√”)
                                  </td>
                                </tr>
                                <tr>
                                  <td height="46" colspan="4">
                                    &nbsp;
                                    <br />
                                    <br />
                                    &nbsp;&nbsp;经办人（签字）：
                                    <input
                                      :value="aBill.a5"
                                      name="A[0].a5"
                                      cname="a5"
                                      type="text"
                                      style="width: 65px"
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;企业（印章）
                                    <br />
                                    &nbsp;&nbsp;
                                    <input
                                      :value="aBill.a71"
                                      name="A[0].a71"
                                      cname="a71"
                                      style="width: 35px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    年
                                    <input
                                      :value="aBill.a72"
                                      name="A[0].a72"
                                      cname="a72"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    月
                                    <input
                                      :value="aBill.a73"
                                      name="A[0].a73"
                                      cname="a73"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input
                                      :value="aBill.a74"
                                      name="A[0].a74"
                                      cname="a74"
                                      style="width: 35px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    年
                                    <input
                                      :value="aBill.a75"
                                      name="A[0].a75"
                                      cname="a75"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    月
                                    <input
                                      :value="aBill.a76"
                                      name="A[0].a76"
                                      cname="a76"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    日
                                  </td>
                                </tr>
                                <tr>
                                  <td height="66" align="center">
                                    区县级
                                    <br />
                                    税务机
                                    <br />
                                    关意见
                                  </td>
                                  <td colspan="4">
                                    &nbsp;批准最高开票限额：
                                    <input
                                      :value="aBill.a36"
                                      name="A[0].a36"
                                      cname="a36"
                                      type="text"
                                      style="width: 150px"
                                    />
                                    <br />
                                    <br />
                                    &nbsp;经办人（签字）：
                                    <input
                                      :value="aBill.a7"
                                      name="A[0].a7"
                                      cname="a7"
                                      type="text"
                                      style="width: 65px"
                                    />
                                    批准人（签字）：
                                    <input
                                      :value="aBill.a8"
                                      name="A[0].a8"
                                      cname="a8"
                                      type="text"
                                      style="width: 65px"
                                    />
                                    税务机关（印章）
                                    <br />
                                    <input
                                      :value="aBill.a77"
                                      name="A[0].a77"
                                      cname="a77"
                                      style="width: 35px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    年
                                    <input
                                      :value="aBill.a78"
                                      name="A[0].a78"
                                      cname="a78"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    月
                                    <input
                                      :value="aBill.a79"
                                      name="A[0].a79"
                                      cname="a79"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input
                                      :value="aBill.a80"
                                      name="A[0].a80"
                                      cname="a80"
                                      style="width: 35px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    年
                                    <input
                                      :value="aBill.a81"
                                      name="A[0].a81"
                                      cname="a81"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    月
                                    <input
                                      :value="aBill.a82"
                                      name="A[0].a82"
                                      cname="a82"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input
                                      :value="aBill.a83"
                                      name="A[0].a83"
                                      cname="a83"
                                      style="width: 35px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    年
                                    <input
                                      :value="aBill.a84"
                                      name="A[0].a84"
                                      cname="a84"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    月
                                    <input
                                      :value="aBill.a85"
                                      name="A[0].a85"
                                      cname="a85"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    日
                                  </td>
                                </tr>
                                <tr>
                                  <td align="center">
                                    地市级
                                    <br />
                                    税务机
                                    <br />
                                    关意见
                                  </td>
                                  <td colspan="4">
                                    &nbsp;批准最高开票限额：
                                    <input
                                      :value="aBill.a37"
                                      name="A[0].a37"
                                      cname="a37"
                                      type="text"
                                      style="width: 150px"
                                    />
                                    <br />
                                    <br />
                                    &nbsp;经办人（签字）：
                                    <input
                                      :value="aBill.a9"
                                      name="A[0].a9"
                                      cname="a9"
                                      type="text"
                                      style="width: 65px"
                                    />
                                    批准人（签字）：
                                    <input
                                      :value="aBill.a10"
                                      name="A[0].a10"
                                      cname="a10"
                                      type="text"
                                      style="width: 65px"
                                    />
                                    税务机关（印章）
                                    <br />
                                    <input
                                      :value="aBill.a11"
                                      name="A[0].a11"
                                      cname="a11"
                                      style="width: 35px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    年
                                    <input
                                      :value="aBill.a12"
                                      name="A[0].a12"
                                      cname="a12"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    月
                                    <input
                                      :value="aBill.a13"
                                      name="A[0].a13"
                                      cname="a13"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input
                                      :value="aBill.a14"
                                      name="A[0].a14"
                                      cname="a14"
                                      style="width: 35px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    年
                                    <input
                                      :value="aBill.a15"
                                      name="A[0].a15"
                                      cname="a15"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    月
                                    <input
                                      :value="aBill.a16"
                                      name="A[0].a16"
                                      cname="a16"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input
                                      :value="aBill.a17"
                                      name="A[0].a17"
                                      cname="a17"
                                      style="width: 35px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    年
                                    <input
                                      :value="aBill.a18"
                                      name="A[0].a18"
                                      cname="a18"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    月
                                    <input
                                      :value="aBill.a19"
                                      name="A[0].a19"
                                      cname="a19"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    日
                                  </td>
                                </tr>
                                <tr>
                                  <td height="61" align="center">
                                    省级税
                                    <br />
                                    务机关
                                    <br />
                                    意见
                                  </td>
                                  <td colspan="4">
                                    &nbsp;批准最高开票限额：
                                    <input
                                      :value="aBill.a38"
                                      name="A[0].a38"
                                      cname="a38"
                                      type="text"
                                      style="width: 150px"
                                    />
                                    <br />
                                    <br />
                                    &nbsp;经办人（签字）：
                                    <input
                                      :value="aBill.a6"
                                      name="A[0].a6"
                                      cname="a6"
                                      type="text"
                                      style="width: 65px"
                                    />
                                    批准人（签字）：
                                    <input
                                      :value="aBill.a0"
                                      name="A[0].a20"
                                      cname="a20"
                                      type="text"
                                      style="width: 65px"
                                    />
                                    税务机关（印章）
                                    <br />
                                    <input
                                      :value="aBill.a11"
                                      name="A[0].a21"
                                      cname="a21"
                                      style="width: 35px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    年
                                    <input
                                      :value="aBill.a22"
                                      name="A[0].a22"
                                      cname="a22"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    月
                                    <input
                                      :value="aBill.a23"
                                      name="A[0].a23"
                                      cname="a23"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input
                                      :value="aBill.a24"
                                      name="A[0].a24"
                                      cname="a24"
                                      style="width: 35px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    年
                                    <input
                                      :value="aBill.a25"
                                      name="A[0].a25"
                                      cname="a25"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    月
                                    <input
                                      :value="aBill.a26"
                                      name="A[0].a26"
                                      cname="a26"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input
                                      :value="aBill.a27"
                                      name="A[0].a27"
                                      cname="a27"
                                      style="width: 35px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    年
                                    <input
                                      :value="aBill.a28"
                                      name="A[0].a28"
                                      cname="a28"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    月
                                    <input
                                      :value="aBill.a29"
                                      name="A[0].a29"
                                      cname="a29"
                                      style="width: 20px; text-align: right"
                                      type="text"
                                      class="isDate"
                                    />
                                    日
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：本申请表一式两联：第一联，申请企业留存；第二联，区县级税务机关留存。
                  </td>
                </tr>
                <tr></tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { environment } from '@/utils/oss.env'
export default {
  props: {
    bgDatas: { type: Array, default: () => [] },
  },
  data() {
    return {
      aBill: [],
      cachetDate: [],
    }
  },
  mounted() {
    this.initABData()
  },
  methods: {
    initABData() {
      const bList = []
      for (const index in this.bgDatas) {
        if (this.bgDatas[index]['a'] !== undefined) {
          this.aBill = this.bgDatas[index]['a']
        } else if (this.bgDatas[index]['c'] !== undefined) {
          const bl = this.bgDatas[index]['c']
          for (const jIndex in bl) {
            const b = bl[jIndex]
            const t = { imgUrl: '', x: '', y: '' }
            t.imgUrl = environment.cacheUrl + b.imgUrl
            t.x = b.x + 'px'
            t.y = b.y + 'px'
            bList.push(t)
          }
        }
      }

      this.cachetDate = bList
    },
  },
}
</script>

<style lang="less" scoped>
#LayerBill {
  position: relative;
  top: 0;
  left: 0;
  width: 700px;
  height: 700px;
  background: url(~@/assets/odiv_zgkpxesqb.jpg);
}

#paperBg {
  position: absolute;
  top: 0;
  left: -1px;
  z-index: 1;
  width: 700px;
  height: 700px;
}

TABLE.outtable {
  font-family: Tahoma;
  font-size: 12px;
  color: #000000;
}

TABLE.thickbordertable {
  border: 1px solid #000000;
}

TABLE.billtable {
  width: 100%;
  font-family: Tahoma;
  font-size: 12px;
  color: #000000;
  white-space: nowrap;
  border-top: 1px solid #000000;
  border-left: 0px;
  border-right: 1px solid #000000;
  border-bottom: 0px;
}

.billtable TD {
  border-top: 0px;
  border-left: 1px solid #000000;
  border-right: 0px;
  border-bottom: 1px solid #000000;
}

INPUT {
  font-family: '楷体_GB2312', '楷体';
  font-size: 12px;
  font-weight: bold;
  background-color: transparent;
  background: none;
  constter-spacing: 0px;
  word-spacing: normal;
  border: 1px none #cccccc;
  overflow: hidden;
  width: 100%;
  line-height: 18px;
}

.cacheImg {
  position: absolute;
  z-index: 1000;
  margin-top: 30px;
}
</style>
